import React from "react";
import { Container, Badge } from "react-bootstrap";
import AppNavbar from "../../../components/common/AppNavbar";

const USStudentVisaFinalRule2026 = () => {
  return (
    <>
      <AppNavbar />
      <div style={{ background: "#f4f7fb" }}>
        {/* HERO SECTION */}
        <div
          style={{
            background: "linear-gradient(135deg, #0f2027, #203a43, #2c5364)",
            color: "white",
            padding: "60px 0",
          }}
        >
          <Container>
            <Badge bg="warning" text="dark" className="mb-3">
              Immigration Update July 2026
            </Badge>
            <h1 className="fw-bold">
              United States DHS Administration Issues Final Rule to End Foreign
              Student Visa Abuse
            </h1>
            <p className="lead mt-3" style={{ maxWidth: "900px" }}>
              A final DHS rule scraps the decades-old "duration of status"
              system for F, J, and I visa holders, replacing it with fixed
              admission periods and mandatory federal extensions — a change that
              will directly affect the hundreds of thousands of Indian students
              currently studying in the US.
            </p>
          </Container>
        </div>

        <section className="immigration-article">
          <div className="container pt-4">
            <p className="text-muted mb-1">
              <strong>Release Date:</strong> July 16, 2026
            </p>
            <p className="fst-italic mb-4">
              Student visa extensions are only available with rigorous vetting
            </p>

            <h2>
              DHS Ends "Duration of Status" for Foreign Students and Exchange
              Visitors
            </h2>

            <p>
              The Department of Homeland Security (DHS) has published a final
              rule eliminating the "duration of status" provision that has
              allowed foreign students, exchange visitors, and media
              representatives to remain in the United States indefinitely
              without routine government oversight. In its place, DHS is
              introducing a fixed period of admission for nonimmigrant visa
              holders in the F, J, and I classifications, bringing student and
              exchange visas in line with most other nonimmigrant visa
              categories that already carry set end dates.
            </p>

            <p>
              DHS Secretary Markwayne Mullin said the decades-old system had
              left room for fraud and weakened national security, and that
              moving to fixed, finite limits restores the government's ability
              to properly screen and monitor visa holders inside the country. He
              added that the change is meant to keep the focus of foreign
              students on completing their studies and returning home.
            </p>

            <hr />

            <h3>The "Forever Student" Loophole</h3>

            <p>
              Since 1978, foreign students have been admitted to the US for an
              unspecified period tied to their academic program rather than a
              fixed date. DHS says this open-ended structure allowed some visa
              holders to become "forever students," repeatedly enrolling in new
              courses of study to avoid ever having to leave the country. The
              final rule is designed to close that loophole through several
              structural changes.
            </p>

            <hr />

            <h3>Key Changes Under the Final Rule</h3>

            <h4>What's Changing</h4>
            <ul>
              <li>
                <strong>Fixed admission caps:</strong> F visa students and J
                visa exchange visitors will now be admitted for the length of
                their specific program, capped at a maximum of{" "}
                <strong>four years</strong>, rather than an open-ended duration.
              </li>
              <li>
                <strong>Federal extension applications:</strong> Anyone needing
                more time to finish a program must file an Extension of Stay
                (EOS) directly with US Citizenship and Immigration Services
                (USCIS), shifting oversight away from university staff and back
                to federal authorities — and subjecting applicants to biometric
                checks, background screening, and fraud vetting.
              </li>
              <li>
                <strong>Shorter departure grace period:</strong> The window for
                F-1 students to leave the country, transfer schools, or change
                status after graduating is cut from{" "}
                <strong>60 days to 30 days</strong>.
              </li>
              <li>
                <strong>Tighter program-change rules:</strong> New restrictions
                limit how freely students can switch academic programs or fields
                of study while on status.
              </li>
            </ul>

            <hr />

            <h3>Timeline and Transition for Current Visa Holders</h3>

            <p>
              The final rule is expected to publish in the Federal Register
              within the next few days and will take effect{" "}
              <strong>60 days</strong> after that publication. Nonimmigrant visa
              holders already in the US under the old "duration of status"
              framework will move to the new fixed-term system automatically,
              with their authorized stay capped at a maximum of four years
              measured from the rule's effective date.
            </p>

            <hr />

            <h3>Why This Matters for Indian Students</h3>

            <p>
              India remains the largest source of international students in the
              United States, and Indian nationals also make up a significant
              share of J-1 exchange visitors and dependents affected by related
              visa categories. With SEVP-tracked oversight tightening and
              extensions now routed through USCIS rather than handled at the
              university level, Indian students and their families should expect
              longer processing times, additional vetting steps, and less
              flexibility around program changes and post-graduation timelines
              than under the old system.
            </p>

            <hr />

            <h3>About SEVP</h3>

            <p>
              The Student and Exchange Visitor Program (SEVP) serves as the link
              between the federal government and the international student
              community. Managed by US Immigration and Customs Enforcement on
              behalf of DHS, SEVP oversees schools, nonimmigrant students in the
              F and M visa classifications, and their dependents, using the
              Student and Exchange Visitor Information System to track and
              monitor schools, exchange visitor programs, and international
              students throughout their time in the US education system.
            </p>

            <hr />

            <h3>Summary</h3>

            <h4>For Current and Prospective Students:</h4>
            <ul>
              <li>
                "Duration of status" is replaced by a fixed admission period,
                capped at four years
              </li>
              <li>
                Extensions must now be filed federally through USCIS, with
                biometric and background vetting
              </li>
              <li>
                Post-graduation grace period cut in half, from 60 to 30 days
              </li>
              <li>Stricter limits on changing academic programs</li>
            </ul>

            <h4>Key Dates:</h4>
            <ul>
              <li>Final rule announced: July 16, 2026</li>
              <li>Federal Register publication: expected within days</li>
              <li>Effective date: 60 days after publication</li>
            </ul>

            <p>
              The rule marks one of the most significant changes to US student
              and exchange visa policy in nearly five decades, and Indian
              students currently in the US or planning to apply should factor
              the new fixed timelines and federal extension process into their
              academic planning.
            </p>
          </div>
        </section>
      </div>
    </>
  );
};

export default USStudentVisaFinalRule2026;
